import { Check } from "lucide-react";
import { Reveal, Overline } from "./primitives";

const SITUATIONS = [
  "Ti senti fermo spiritualmente",
  "Fai fatica a gestire emozioni e pensieri",
  "Vivi relazioni complicate",
  "Lotti con dipendenze o abitudini distruttive",
  "Senti di aver perso direzione",
  "Vuoi rimettere Dio al centro in modo concreto",
  "Hai bisogno di essere ascoltato davvero",
];

export const ForWhoSection = () => (
  <section className="relative bg-white/[0.02] py-28 sm:py-36" data-testid="forwho-section">
    <div className="mx-auto max-w-5xl px-6 sm:px-8">
      <Reveal className="max-w-3xl">
        <Overline>Per chi è</Overline>
        <h2 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.02] tracking-tight text-white">
          Quando richiedere la{" "}
          <span className="italic text-gold">Mappa del Tempio?</span>
        </h2>
        <p className="mt-8 text-base sm:text-lg font-light leading-relaxed text-white/75">
          Se senti di essere in una fase di confusione, blocco, peso interiore o battaglia
          personale, questo incontro può aiutarti a fermarti, rileggere ciò che stai vivendo e
          fare un primo passo.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-x-14 sm:grid-cols-2" data-testid="forwho-list">
        {SITUATIONS.map((s, i) => (
          <Reveal key={s} delay={i * 0.05}>
            <div className="group flex items-start gap-4 border-b border-white/10 py-5">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-gold/50 transition-colors duration-300 group-hover:bg-gold/10">
                <Check className="h-3.5 w-3.5 text-gold" />
              </span>
              <p className="text-base sm:text-lg font-light leading-relaxed text-white/85">{s}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
